/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import linkedGoalsQueryParameters from '@jira/spa-apps__goals-linked-goals/src/__generated__/LinkedGoalsQuery$parameters.ts';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type {
	SoftwareGoalsExtraProps,
	SoftwareGoalsQueries,
	SoftwareGoalsRuntimeProps,
} from './softwareGoals.entrypoint.types.tsx';

type SoftwareGoalsEntrypointComponent = EntryPointComponent<
	SoftwareGoalsQueries,
	{},
	SoftwareGoalsRuntimeProps,
	SoftwareGoalsExtraProps
>;

export const softwareGoalsEntrypoint: EntryPoint<
	SoftwareGoalsEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<SoftwareGoalsEntrypointComponent>(
		/* webpackChunkName: "async-atlas-goals-entrypoint" */ './SoftwareGoalsComponent.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ tenantContext: { cloudId }, context: { match } }: EntryPointRouteParams) => {
		const { projectKey } = match.params;
		return {
			queries: {
				linkedGoalsQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters: linkedGoalsQueryParameters,
					variables: {
						projectKey: projectKey ?? '',
						cloudId,
						cloudIdAsId: cloudId,
						first: 15,
						after: null,
					},
				},
			},
			extraProps: {
				cloudId,
				projectKey: projectKey ?? undefined,
			},
		};
	},
});
